export interface CourseData {
  currency?: string;
  name: string;
  id: number;

  institute_name: string;
  degreelevel_name: string;
  qs_ranking: number;
  studyMode: string;
  course_fee: number | null;
  duration: string;
  course_language: string;
  logo: string;
  course_slug?: string;
  duration_id?: number;
  course_fee_id?: number;
  institute_slug?: string;
  degree_level?: string;
  institute_sector?: string;
  display_order?: number;
  base_fee?: number;
  course_id?: number;
  language?: string;
  slug?: string;
}

export interface TopInstitutesLabels {
  viewCourses: string;
  viewUniversity: string;
  institute_type?: string;
  established: string;
  slug?: string;
  campuses?: string[];
  sector: string;
  ranking: string;
  logo?: string;
  institute_name?: string;
}
export interface TopPicksLabels {
  id?: number;
  institute_slug?: string;
  slug?: string;
  duration_id?: string;
  course_fee_id?: string;
  institute_sector?: string;
  degree_level?: string;
  base_fee?: string;
  degree: string;
  sector: string;
  display_order: string;
  fee: string;
  language: string;
  duration: string;
  name?: string;
  institute_name?: string;
  logo?: string;
}

export interface Labels {
  degree: string;
  uniRating: string;
  studyMode: string;
  fee: string;
  duration: string;
  language: string;
  checkEligibility: string;
  viewDetail: string;
}

export interface CourseData {
  name: string;
  institute_name: string;
  degreelevel_name: string;
  qs_ranking: number;
  studyMode: string;
  fee?: number;
  duration: string;
  course_fee: number | null;
  course_language: string;
  logo: string;
}

export interface CourseCard {
  labels: Labels;
  courses: CourseData[];
  defaultImage: string;
  altImage: string;
  defaultFee: string;
}

export interface GradientHeading {
  title: string;
  paragraph: string;
}

interface SearchResults {
  heading: string;
  clear: string;
  filterHeadline: string;
  filterButtonText: string;
  sortButtonText: string;
  currencyButtonText: string;
  checkBoxButtonText: string;
}
interface SortBy {
  option1: string;
  option2: string;
  option3: string;
  option4: string;
}

interface Currency {
  name: string;
  symbol: string;
  flag: string;
  code: string;
}

interface Filters {
  option1: string;
  option2: string;
  option3: string;
}

export const filterData: Filters = {
  option1: "Graduate Diploma",
  option2: "University",
  option3: "UK",
};

export const sortByData: SortBy = {
  option1: "Fee low to high",
  option2: "Fee high to low",
  option3: "Duration",
  option4: "QS ranking",
};

export const currencyData: Currency[] = [
  { name: "Australian Dollar", symbol: "AUD", flag: "", code: "AUD" },
  { name: "Brazilian Real", symbol: "BRL", flag: "", code: "BRL" },
  { name: "British Pound", symbol: "GBP", flag: "", code: "GBP" },
  { name: "Bulgarian Lev", symbol: "BGN", flag: "", code: "BGN" },
  { name: "Canadian Dollar", symbol: "CAD", flag: "", code: "CAD" },
  { name: "Chinese Yuan Renminbi", symbol: "CYN", flag: "", code: "CYN" },
  { name: "Czech Koruna", symbol: "CZK", flag: "", code: "CZK" },
  { name: "Danish Krone", symbol: "DKK", flag: "", code: "DKK" },
  { name: "Euro", symbol: "EUR", flag: "", code: "EUR" },
  { name: "Hungarian Forint", symbol: "HUF", flag: "", code: "HUF" },
  { name: "Icelandic Krona", symbol: "ISK", flag: "", code: "ISK" },
  { name: "Indian Rupee", symbol: "INR", flag: "", code: "INR" },
];

export const gradientHeadingData: GradientHeading = {
  title: "found based on your selection",
  paragraph:
    "Explore the options below to find the best fit for your needs. You can use filters to narrow down your search and discover opportunities tailored to your preferences. Select a program to learn more, check eligibility, and start your journey today.",
};
export const gradientHeadingEnglishCoursesData: GradientHeading = {
  title: "found based on your selection",
  paragraph:
    "Here are the English courses that match your search. Explore the list, check the details, and save the courses you’re interested in. If you need more options, adjust the filters and search again.",
};
export const gradientHeadingScholarshipSearchData: GradientHeading = {
  title: "found based on your selection",
  paragraph:
    "Here’s a list of scholarships that match your search. Check out the eligibility, deadlines, and award amounts of each, compare the details, and save the ones you are interested in applying to. And don’t forget to apply here when you find the best match!",
};

export const gradientHeadingUniversitySearchData: GradientHeading = {
  title: "found based on your selection",
  paragraph:
    "Here’s a list of universities that match your search. Check out the list, compare university rankings and programs, and save the ones you are interested in applying to. ",
};

export const gradientHeadingCourseSearchData: GradientHeading = {
  title: "found based on your selection",
  paragraph:
    "Here’s a list of courses that match your search. Explore the options, review details including course duration and level, and save your favorites. When you find the right fit, go ahead and apply.",
};

export const gradientHeadingZeroCoursesData = {
  searching: "Searching for your ",
  title: "Oops! we did not find any results",
  paragraph:
    "Sorry, we couldn’t find any matches for your search. Try adjusting your filters or using different keywords. You can also explore our featured courses, universities, or scholarships for more options.",
};

export const searchResultsData: SearchResults = {
  heading: "Selected filters",
  clear: "Clear all filters",
  filterHeadline:
    "Save your filters for future searches to quickly access tailored results next time.",
  filterButtonText: "Filters",
  sortButtonText: "Sort by",
  currencyButtonText: "Currency",
  checkBoxButtonText: "panel",
};

export const courseSearchData: CourseCard = {
  defaultImage: "/images/university-logo-default.png",
  altImage: "Course Image",
  defaultFee: "To Be Confirmed",
  labels: {
    degree: "Degree",
    uniRating: "Rank",
    studyMode: "Study mode",
    fee: "Fee",
    duration: "Duration",
    language: "Language",
    checkEligibility: "Apply now",
    viewDetail: "View detail",
  },
  courses: [
    {
      id: 1,
      name: "Bachelor of Architectural Engineering (Hons) with Year Abroad",
      institute_name: "Yale University, UK",
      degreelevel_name: "Bachelors",
      qs_ranking: 308,
      studyMode: "On campus",
      course_fee: 14900,
      duration: "4 years",
      course_language: "English",
      logo: "/images/university-logo.png",
      currency: "$",
    },
    {
      id: 2,
      name: "Bachelor of Architectural Engineering (Hons) with Year Abroad",
      institute_name: "Yale University, UK",
      degreelevel_name: "Bachelors",
      qs_ranking: 307,
      studyMode: "On campus",
      course_fee: 14900,
      duration: "4 years",
      course_language: "English",
      logo: "",
      currency: "$",
    },
  ],
};

export const topPicksLabelsData: TopPicksLabels = {
  degree: "Degree",
  sector: "Status",
  display_order: "Order",
  duration: "Duration",
  fee: "Fee",
  language: "Language",
};

export const topInstitutesLabelsData: TopInstitutesLabels = {
  viewUniversity: "View University",
  viewCourses: "View Courses",
  established: "Established",
  sector: "Sector",
  ranking: "Ranking",
};
